<template>
    <div class="block-editor insert-to-system-prompt">
        <div class="wrapper">
            <div class="title">Sistem Promptuna Eklenecek Mesaj</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    placeholder="AI asistanının sistem promptuna eklenecek mesajınızı buraya yazınız. Bu mesaj session boyunca sistem promptuna eklenecektir."
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.message"
                    :max-character-count="4096"
                />
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";

const log = log2("InsertToSystemPrompt");
export default {
    name: "InsertToSystemPrompt",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.insert-to-system-prompt {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .wrapper {
        padding: 10px;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }
    }
}
</style>

